import { render, staticRenderFns } from "./Initiatives.vue?vue&type=template&id=24817e2b"
import script from "./Initiatives.vue?vue&type=script&lang=ts"
export * from "./Initiatives.vue?vue&type=script&lang=ts"
import style0 from "./Initiatives.vue?vue&type=style&index=0&id=24817e2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports